import React from 'react';
import HeroSection from '../components/ratecard/HeroSection'
import ContextualArticles from '../components/ratecard/ContextualArticles';
import PublicationCalendar from '../components/ratecard/PublicationCalendar';
import PubliNotes from '../components/ratecard/PubliNotes'
import EmailMkt from '../components/ratecard/EmailMkt';
import MicrositesWeb from '../components/ratecard/MicrositesWeb';
import LandingPages from '../components/ratecard/LandingPages';
import DisplayBanners from '../components/ratecard/DisplayBanners';
import RichMediaBanners from '../components/ratecard/RichMediaBanners';
import VideoBanners from '../components/ratecard/VideoBanners';
import EventsBeHealth from '../components/ratecard/EventsBeHealth';
import EventsBeHealthSponsors from '../components/ratecard/EventsBeHealthSponsors';
import LivesPodcastsBeHealth from '../components/ratecard/LivesPodcastsBeHealth';
import OptionsBeAds from '../components/ratecard/OptionsBeAds';
import OptionsBrandedContent from '../components/ratecard/OptionsBrandedContent';
import SpecsBeAdsDektop from '../components/ratecard/SpecsBeAdsDektop';
import SpecsBeAdsMobile from '../components/ratecard/SpecsBeAdsMobile';

const RateCard = () => {
    return (
        <div>
            <HeroSection />
            <ContextualArticles />
            <PublicationCalendar />
            <PubliNotes />
            <EmailMkt />
            <MicrositesWeb />
            <LandingPages />
            <DisplayBanners />
            <RichMediaBanners />
            <VideoBanners />
            <EventsBeHealth />
            <EventsBeHealthSponsors />
            <LivesPodcastsBeHealth />
            <OptionsBeAds />
            <OptionsBrandedContent />
            <SpecsBeAdsDektop />
            <SpecsBeAdsMobile />
        </div>
    );
};

export default RateCard;